export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette action supprimera définitivement l'actif"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr de vouloir continuer ?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous ne verrez plus cet actif dans votre liste."])}
}